export default __webpack_public_path__ + "static/google_Desktop6-bf45b6f91025742bc51f1d92863f76c5.svg";